import React from 'react';
import { ErrorPage } from './ErrorPage';
import { useNavigate } from 'react-router-dom';

interface ErrorPageTemplateProps {
  ref?: React.MutableRefObject<HTMLDivElement | null>;
  errorHeader: string;
  errorInfo?: string | React.ReactNode;
  navButtonLabel?: string;
  navigateTo?: () => void;
}

export const NotFoundErrorContent = () => {
  return (
    <div className="text-bodyLg flex flex-col gap-6">
      <p>If you typed the web address, check that it is correct.</p>
      <p>
        If you pasted the web address, check that you have copied the full
        address.
      </p>
      <p>
        If you still need help, contact us on{' '}
        <a href="tel:02076412000" className="font-bold underline">
          020 7641 2000
        </a>
      </p>
    </div>
  );
};

export const InternalServerErrorContent = () => {
  return (
    <p className="text-bodyLg">
      Please try again later or contact us on{' '}
      <a href="tel:02076412000" className="font-bold underline">
        020 7641 2000
      </a>
    </p>
  );
};

export const ErrorPageTemplate: React.FC<ErrorPageTemplateProps> = ({
  navigateTo,
  ref,
  errorHeader,
  errorInfo,
  navButtonLabel,
}: ErrorPageTemplateProps) => {
  return (
    <div ref={ref} className="container h-screen p-0">
      <ErrorPage
        errorHeader={errorHeader}
        errorInfo={errorInfo}
        navButtonLabel={navButtonLabel}
        navigateTo={navigateTo}
      />
    </div>
  );
};

export const notFoundErrorTemplateProps = {
  errorHeader: 'Page not found',
  errorInfo: <NotFoundErrorContent />,
};

export const internalServerErrorTemplateProps = {
  errorHeader: 'Sorry, there is a problem with the website',
  errorInfo: <InternalServerErrorContent />,
  navButtonLabel: 'Back to previous page',
  navigateTo: () => {},
};

export const NotFoundErrorTemplate = () => {
  return <ErrorPageTemplate {...notFoundErrorTemplateProps} />;
};

export const InternalServerErrorTemplate = () => {
  const navigate = useNavigate();
  return (
    <ErrorPageTemplate
      {...internalServerErrorTemplateProps}
      navigateTo={() => navigate(-1)}
    />
  );
};
